<template>
  <v-card class="d-flex align-center justify-center" light outlined>
    <div>
      <v-card-title class="text-center" style="background-color: #d2d7e1">
        <v-list-item>
          <v-list-item-title><h2>Register Participant</h2>
            <p class="mb-0">Register a participant to a single tournament</p></v-list-item-title>
        </v-list-item>
      </v-card-title>
      <v-card-text class="px-7 pt-3">
        <v-form v-model="valid">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="12" md="12" lg="4" xl="4">
                <v-select :items="tournaments" item-text="name" item-value="id" v-model="tournamentSelected"
                          :rules="tournamentRule" label="Tournament" outlined prepend-icon="fa-trophy"/>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4" xl="4">
                <v-autocomplete v-model="userParticipant" :items="this.$store.state.users" :return-object="false" :rules="userRule"
                                item-text="user.email" @change="userChanged" item-value="user.id" label="User" outlined prepend-icon="fa-user"/>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="4" xl="4">
                <v-autocomplete v-model="userAccount" :disabled="userParticipant === 0" :items="userVerifiedAccounts" :return-object="false"
                                :rules="accountRule" item-value="id" label="Broker Account" outlined prepend-icon="fa-university">
                  <template v-slot:selection="data">
                    {{ (data.item.broker.name !== 'All')? ((data.item.identifier !== '')? data.item.identifier : data.item.broker.name): 'All' }}
                    <v-icon v-if="data.item.verified" color="blue" class="ml-2" small>fa-check-circle</v-icon>
                  </template>
                  <template v-slot:item="data">
                    {{ (data.item.identifier !== '')? `${data.item.broker.name} · ${data.item.identifier}` :  data.item.broker.name }}
                    <v-icon v-if="data.item.verified" color="blue" class="ml-2" small>fa-check-circle</v-icon>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row align="center" justify="center">
              <v-btn class="mt-n3" outlined @click="enrollParticipant">Enroll Participant</v-btn>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import Repository from '../../../repositories/helpDesk';
export default {
  name: "RegisterToTournament",
  data() {
    return {
      tournaments: [],
      tournamentSelected: 0,

      userParticipant: 0,
      userAccount: 0,
      userVerifiedAccounts: [],

      // Form related rules
      valid: false,
      tournamentRule: [
          t => !!t || 'Tournament is mandatory',
      ],
      userRule: [
          u => !!u || 'User is mandatory',
      ],
      accountRule: [
          a => !!a || 'Account is mandatory',
      ],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.getTournaments();
    },
    getTournaments() {
      Repository.getTournaments().then((response) => {
        if (response.status < 400) {
          this.tournaments = response.data;
          this.tournamentSelected = this.tournaments[this.tournaments.length - 1].id;
        }
      });
    },
    async userChanged() {
      let alreadyEnrolled;
      await Repository.findParticipantByTournament(this.tournamentSelected, this.userParticipant).then(async (response) => {
        if(response.status < 400) {
          alreadyEnrolled = await response.data !== null;
        }
      });

      if(alreadyEnrolled)
          alert('User is already enrolled to the tournament.');
      else
        Repository.allBrokerAccountsOfUser(this.userParticipant).then((response) => {
          if(response.status < 400) {
            this.userVerifiedAccounts = response.data.filter((account) => account.verified);
          }
        });
    },
    enrollParticipant() {
      if(this.valid) {
        let tournamentParticipant = {
          tournament: { id: this.tournamentSelected },
          assignedAccount: { id: this.userAccount },
          user: { id: this.userParticipant },
        };

        Repository.enrollParticipant(tournamentParticipant).then((response) => {
          if (response.status < 400 && response.data) {
            alert(`Congrats! The ${this.userParticipant} user was successfully registered on our tournament!`);
            this.userParticipant = 0;
            this.userAccount = 0;
          }
        });
      }
    },
  },
}
</script>

<style scoped>

</style>
